import * as S from './styles';

function SpinnerMini() {
  return <S.Spin></S.Spin>;
}

export default SpinnerMini;
